var _circle, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcologic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.666,
    cy: 64,
    r: 63.5,
    stroke: "url(#paint0_linear_2577_2880)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.44 26H84.9385C73.848 26 64.8252 35.0228 64.8252 46.1133V60.7389C65.0346 60.5009 65.2508 60.2673 65.4774 60.0408L82.1716 43.3464C83.041 42.4769 84.4509 42.4769 85.3205 43.3464C86.19 44.216 86.19 45.6257 85.3205 46.4952L68.6261 63.1896C68.4161 63.3996 68.2176 63.6178 68.0285 63.8418H82.5536C93.6441 63.8418 102.667 54.819 102.667 43.7285V28.2266C102.667 26.9969 101.67 26 100.44 26Z",
    fill: "url(#paint1_linear_2577_2880)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8877 28.2266C35.8877 26.9969 34.8908 26 33.6611 26C32.4315 26 31.4346 26.9969 31.4346 28.2266V35.8563H35.8877V28.2266Z",
    fill: "url(#paint2_linear_2577_2880)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1983 28.2266C50.1983 26.9969 49.2013 26 47.9717 26C46.742 26 45.7451 26.9969 45.7451 28.2266V35.8563H50.1983V28.2266Z",
    fill: "url(#paint3_linear_2577_2880)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0927 80.8526H75.9409C71.7414 80.8526 67.9895 78.3455 66.3822 74.4655C65.5375 72.426 65.381 70.2356 65.8531 68.1851C64.266 67.8964 62.8723 67.0467 61.8877 65.8477C60.7906 69.1498 60.8736 72.8032 62.268 76.1697C64.567 81.7198 69.9339 85.3059 75.9407 85.3059H92.0926C95.4777 85.3059 98.2131 88.044 98.2131 91.4265C98.2132 94.8013 95.4676 97.547 92.0927 97.547H52.7418C47.3777 97.547 43.044 93.2052 43.044 87.8491V68.1611C42.3136 68.2485 41.5709 68.2948 40.8174 68.2948C40.0639 68.2948 39.3211 68.2485 38.5908 68.1611V87.849C38.5908 95.6762 44.9261 102 52.7418 102H92.0927C97.923 102 102.666 97.2568 102.666 91.4265C102.666 85.5767 97.9333 80.8526 92.0927 80.8526Z",
    fill: "url(#paint4_linear_2577_2880)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9682 49.6906V42.5359C54.9682 41.3062 53.9713 40.3093 52.7416 40.3093H28.8926C27.6629 40.3093 26.666 41.3062 26.666 42.5359V49.6906C26.666 57.5179 33.0015 63.8416 40.817 63.8416C48.6455 63.8416 54.9682 57.5053 54.9682 49.6906Z",
    fill: "url(#paint5_linear_2577_2880)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2577_2880",
    x1: 7.55245,
    y1: 18.7399,
    x2: 120.519,
    y2: 75.2731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2577_2880",
    x1: 66.8611,
    y1: 31.5402,
    x2: 100.258,
    y2: 48.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2577_2880",
    x1: 31.6742,
    y1: 27.443,
    x2: 36.3495,
    y2: 28.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2577_2880",
    x1: 45.9847,
    y1: 27.443,
    x2: 50.6601,
    y2: 28.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2577_2880",
    x1: 42.0381,
    y1: 71.1405,
    x2: 81.6147,
    y2: 106.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2577_2880",
    x1: 28.1887,
    y1: 43.7546,
    x2: 51.1165,
    y2: 57.5544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6A632"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcologic);
export default __webpack_public_path__ + "static/media/ecologic.0b765c1ed789734144bcad2e89546f30.svg";
export { ForwardRef as ReactComponent };